import React from "react";
import ClientWorkDashboard from "../../Operations/ClientWork/ClientWorkDashboard";
import ClientWorkReports from "../../Operations/ClientWork/ClientWorkReports";
import ContractBillingAbstractReport from "../../Operations/ClientWork/Reports/ContractBillingAbstractReport";
import RetentionLedgerReport from "../../Operations/ClientWork/Reports/RetentionLedgerReport";
import MobilizationAdvanceReport from "../../Operations/ClientWork/Reports/MobilizationAdvanceReport";
import ClientARAgingReport from "../../Operations/ClientWork/Reports/ClientARAgingReport";
import ClientsTable from "../../Operations/ClientWork/Clients/ClientsTable";
import ClientForm from "../../Operations/ClientWork/Clients/ClientForm";
import ContractsTable from "../../Operations/ClientWork/Contracts/ContractsTable";
import ContractForm from "../../Operations/ClientWork/Contracts/ContractForm";
import InvoicesTable from "../../Operations/ClientWork/Invoices/InvoicesTable";
import InvoiceForm from "../../Operations/ClientWork/Invoices/InvoiceForm";

export const clientWorkRoutes = [
  {
    path: "/client-work",
    component: <ClientWorkDashboard />,
    rolename: "Store Work Orders_View",
  },
  {
    path: "/client-work/dashboard",
    component: <ClientWorkDashboard />,
    rolename: "Store Work Orders_View",
  },
  {
    path: "/client-work/clients",
    component: <ClientsTable />,
    rolename: "Store Work Orders_View",
  },
  {
    path: "/client-work/clients/add",
    component: <ClientForm />,
    rolename: "Store Work Orders_View",
  },
  {
    path: "/client-work/clients/edit/:id",
    component: <ClientForm />,
    rolename: "Store Work Orders_View",
  },
  {
    path: "/client-work/contracts",
    component: <ContractsTable />,
    rolename: "Store Work Orders_View",
  },
  {
    path: "/client-work/contracts/add",
    component: <ContractForm />,
    rolename: "Store Work Orders_View",
  },
  {
    path: "/client-work/contracts/edit/:id",
    component: <ContractForm />,
    rolename: "Store Work Orders_View",
  },
  {
    path: "/client-work/invoices",
    component: <InvoicesTable />,
    rolename: "Store Work Orders_View",
  },
  {
    path: "/client-work/invoices/add",
    component: <InvoiceForm />,
    rolename: "Store Work Orders_View",
  },
  {
    path: "/client-work/invoices/edit/:id",
    component: <InvoiceForm />,
    rolename: "Store Work Orders_View",
  },
  {
    path: "/client-work/reports",
    component: <ClientWorkReports />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/client-work/reports/contract-billing-abstract",
    component: <ContractBillingAbstractReport />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/client-work/reports/retention-ledger",
    component: <RetentionLedgerReport />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/client-work/reports/mobilization-advance",
    component: <MobilizationAdvanceReport />,
    rolename: "Store Dashboard_View",
  },
  {
    path: "/client-work/reports/ar-aging",
    component: <ClientARAgingReport />,
    rolename: "Store Dashboard_View",
  },
];
